import { BOOKING_CONSTANTS } from '@hosty-app/core';

export const BOOKING_POLICY_CONSTANT = [
  // { title: 'Quotehold', value: BOOKING_CONSTANTS.BOOKING_POLICY.QUOTEHOLD },
  { title: 'Instant', value: BOOKING_CONSTANTS.BOOKING_POLICY.INSTANT },
];
